import React, { useMemo } from 'react';
import { APITypes } from '../../../../../primary-record-types';
import { Form } from '../../../../v2BaseComponents/Form';
import { handleFormikSubmit } from '../../../../../utils/handleFormikSubmit';
import FormFields, {
    mapFormValuesToRequest,
    FormValue,
    mapInvitationDefinitionToFormValues,
} from '../../../../shared/InvitationDefinitions/FormFields';
import { useIsDisabledByParent } from '../../../../v2BaseComponents/IsDisabledProvider';

export type EditInvitationDefinitionFormOwnProps = {
    invitationDefinition: APITypes.organizationService.GetInvitationDefinitionResponse;
    onUpdate: (InvitationDefinition: APITypes.organizationService.UpdateInvitationDefinitionRequest) => void;
    onCancel: () => void;
};

export type EditInvitationDefinitionFormProps = EditInvitationDefinitionFormOwnProps;

const EditInvitationDefinitionForm: React.FC<EditInvitationDefinitionFormProps> = (props) => {
    const initialValues = useMemo<FormValue>(
        () => mapInvitationDefinitionToFormValues(props.invitationDefinition),
        [props.invitationDefinition],
    );

    const isDisabled = useIsDisabledByParent();

    return (
        <Form
            fillContainer
            actionContainerSubmit
            initialValues={initialValues}
            onSubmit={(values, helpers) => {
                props.onUpdate(mapFormValuesToRequest(values));
                handleFormikSubmit(values, helpers);
            }}
            isDisabled={isDisabled}
            onCancel={props.onCancel}
        >
            {({ values }) => <FormFields isDisabled={isDisabled} value={values} initialValues={initialValues} />}
        </Form>
    );
};

export default React.memo(EditInvitationDefinitionForm);
